import React from 'react'

function TechSelectLtd() {
  return (
    <embed src="\pdfs\E3.3_lt-d_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectLtd